import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <SectionWrapper className="bg-white" data-id="element-94">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="bg-brand-teal/5 rounded-3xl p-8 md:p-12 relative border border-brand-teal/10" data-id="element-96">
          <Quote className="absolute top-6 left-6 w-12 h-12 text-brand-teal/20" data-id="element-97" />

          <div className="relative z-10 text-center" data-id="element-98">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-8" data-id="element-99">
              La Transformación del Lunes
            </h2>

            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium italic mb-8" data-id="element-100">
              "En solo 48 horas de seguir este protocolo, la mayoría de los
              usuarios reportan una pérdida visual de volumen en el rostro,
              manos menos rígidas y un aumento notable en la claridad mental."
            </p>

            <div className="inline-block bg-brand-amber/10 text-brand-amber font-bold px-6 py-3 rounded-full" data-id="element-101">
              No es magia, es lo que ocurre cuando dejas de pelear contra tu
              biología y empiezas a trabajar con ella.
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}